import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import styles from './ChatVideocall.module.sass';
import RoomPeer from "../../../../Conquer/ROOMS/RoomInstance/RoomPeer";
import UserPhoto from "../../../components/UserPhoto";

const ChatVideocall = ({roomInstance, getTargetAvatar, peer }) => {

    const ownVideoRef = useRef();
    const otherVideoRef = useRef();
    const [userData, setUserData] = useState();
    const [localMedia, setLocalMedia] = useState(false);
    const [streamMedia, setStreamMedia] = useState(false);
    const [muteText, setMuteText] = useState('Mute');

    function eventsHandler( action, data ){
        
        if( action == 'onVideoStateChanged' ){
            if( data ) otherVideoRef.current.srcObject = data;
            setStreamMedia( data );
        }

        if( action == 'onLocalVideoStateChanged' ){

            let stream = data ? peer.localStream : undefined;
            ownVideoRef.current.srcObject = stream;
            setLocalMedia( stream );

        }

        if( action == 'onLocalAudioStateChanged' ){ setMuteText( data ? 'Mute' : 'Unmute' ) }
        // if( action == 'onMutedStateChanged' ) setStreamMedia( roomInstance.peer.remoteStream );

    }

    const toggleCamera = async () => { await peer.toggleCamera() };
    const toggleMute = async() => { await peer.toggleMute() };
    
    const stopCall = async() => { await peer.answerCall(false) };

    useEffect(() => {

        otherVideoRef.current.srcObject = peer.remoteStream;
        peer.messageHandler = eventsHandler;

        // window.addEventListener('beforeunload', () => { alert('ON UNLOAD'); roomInstance.reject() });

        // return () => { roomInstance.reject(); console.log('EXITTING') };

    }, []);

    useEffect(() => {
        setUserData( getTargetAvatar() );
    }, [roomInstance]);

    return (
        <div className={styles.videocallContainer}>
            <div className={styles.videos}>
                <div className={styles.videoContainer}>
                    <video ref={ownVideoRef} autoPlay={true} playsInline={true} muted={true} className={localMedia ? "": styles.hide}/>
                    {!localMedia && <UserPhoto fallbackToMe={true} removeOnline={true}/>}
                </div>
                <div className={styles.videoContainer}>
                    <video ref={otherVideoRef} autoPlay={true} playsInline={true} className={streamMedia ? "": styles.hide}/>
                    {!streamMedia && <UserPhoto userData={userData} fallbackToMe={false}  removeOnline={true}/>}
                </div>
            </div>
            <div className={styles.actionBar}>
                <button className='button small' onClick={ toggleCamera }>{localMedia ? 'Stop Video' : 'Show Video'}</button>
                <button className='button small' onClick={ toggleMute }>Mute</button>
                <button className='button small' onClick={ stopCall }>Hang</button>
            </div>
        </div>
    );

};

export default ChatVideocall;